<template>
  <div class="jm-text-center">
    <p class="jm-mb-2">Je réponds aux demandes de :</p>

    <div class="tags-list-container jm-justify-center jm-mb-3">
      <base-tag
        v-for="tag in tags"
        :key="tag.key"
        :label="tag.label"
      ></base-tag>
    </div>
  </div>
</template>

<script>
import BaseTag from '@/components/atoms/BaseTag.vue'

export default {
  name: 'StylistTags',
  components: { BaseTag },
  props: {
    tags: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
.tags-list-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
</style>
